import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import i18n from '@/lang/i18n'
import { ScientificAnalysisDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource'
import { scientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { Nullable } from '@/shared/types/app.types'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { ScientificAnalysisEntityPortion } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-portion'
import { ScientificAnalysisSampleDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-sample'
import { ScientificAnalysisCaseDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-case'
import { ScientificAnalysisPatientDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-patient'

export class ScientificAnalysisPortionDatasource extends ScientificAnalysisDatasource<ScientificAnalysisEntityPortion> {
    public static getEntityGridColumns(selector: string = '', hideAll: boolean = false): (ColDef | ExportedColDef | ExportedColGroupDef) {
        return {
            headerName: i18n.tc(`scientificAnalysis.grid.results.portion.header`),
            children: [
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.id`),
                    exportField: `${selector}label`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}label`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.type`),
                    exportField: `${selector}portionType.potName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}portionType.potName`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.registrationDate`),
                    exportField: `${selector}registrationDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}registrationDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.processingStartDate`),
                    exportField: `${selector}processingStartDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}processingStartDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.processingEndDate`),
                    exportField: `${selector}processingEndDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}processingEndDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.generationEndDate`),
                    exportField: `${selector}generationDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}generationDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.lastCutDate`),
                    exportField: `${selector}lastCutDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}lastCutDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.processingStartPersonnel`),
                    exportField: `${selector}processingStartPersonnel.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}processingStartPersonnel.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.processingEndPersonnel`),
                    exportField: `${selector}processingEndPersonnel.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}processingEndPersonnel.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.generationEndPersonnel`),
                    exportField: `${selector}generationPersonnel.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}generationPersonnel.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.lastCutTechnician`),
                    exportField: `${selector}lastCutTechnician.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}lastCutTechnician.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.microtome`),
                    exportField: `${selector}microtome.device`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}microtome.device`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.protocol`),
                    field: `${selector}protocols`,
                    sortable: false,
                    filter: false,
                    exportDisabled: true,
                    flex: 1,
                    minWidth: 200,
                    hide: true,
                    cellRenderer: ({ data }: ICellRendererParams) => {
                        let value = ``
                        if (data?.protocols?.length > 0) {
                            let protocol
                            for (protocol of data.protocols) {
                                if (protocol.prtName) {
                                    if (value.length > 0) {
                                        value += `;`
                                    }
                                    value += protocol.prtName
                                }
                            }
                        }
                        return value
                    }
                },
                {
                    type: AgGridColumnType.COMMON_PORTION_STATUS,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.state`),
                    exportField: `${selector}state.name`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}state`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.processor`),
                    exportField: `${selector}processor.device`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}processor.device`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.observations`),
                    exportField: `${selector}observations`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}observations`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.hasRevision`),
                    exportField: `${selector}hasRevision`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasRevision`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.hasIncidents`),
                    exportField: `${selector}hasIncidents`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasIncidents`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.hasAttachments`),
                    exportField: `${selector}hasAttachments`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasAttachments`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.portion.depleted`),
                    exportField: `${selector}depleted`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}depleted`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                }

            ]

        }
    }

    public getGridColumns(): (ColDef | ExportedColDef | ExportedColGroupDef)[] {
        return [
            { type: AgGridColumnType.CUSTOM_CHECKBOX },
            ScientificAnalysisPortionDatasource.getEntityGridColumns(),
            ScientificAnalysisSampleDatasource.getEntityGridColumns('sample.', true),
            ScientificAnalysisCaseDatasource.getEntityGridColumns('sample.caseStudy.', true),
            ScientificAnalysisPatientDatasource.getEntityGridColumns('sample.caseStudy.patient.', true)
        ]
    }

    public async paginator(_filterModel: CommonFilterModel, params: CommonParams, scrollId: string, totalElements: number): Promise<InfinitePaginatorResponse<ScientificAnalysisEntityPortion>> {
        const response: InfinitePaginatorResponse<ScientificAnalysisEntityPortion> = await scientificAnalysisService.search(this.scientificAnalysis, params, scrollId, totalElements) as InfinitePaginatorResponse<ScientificAnalysisEntityPortion>
        this.setTotalElements(response.scrollPage.totalElements)
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response?.scrollPage?.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getPatAndLabId(selectedRow: ScientificAnalysisEntityPortion): [number, number] {
        return [selectedRow.sample.caseStudy.patient.id, selectedRow.sample.caseStudy.laboratoryId]
    }

    public getLabAndCaseId(selectedRow: ScientificAnalysisEntityPortion): [number, Nullable<number>] {
        return [selectedRow.sample.caseStudy.laboratoryId, selectedRow.sample.caseStudy.id]
    }

    public getHTMLFieldsList(data: ScientificAnalysisEntityPortion): string[] {
        return []
    }
}
